export const PowerLossIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    height={50}
    viewBox="0 0 47 47">
    <path d="M1 35h1v3H1zm41 12h-4v-1h5v1h-1zm-11-1h5v1h-5zm-7 0h5v1h-5zm-7 0h5v1h-5zm28-1 1-4v-1h1v1l-2 4zm1-12h1v5h-1zM1 28h1v5H1zm45-2h1v5h-1zM1 21h1v5H1zm45-2h1v5h-1zM1 14h1v5H1zm45-2h1v5h-1zM1 7h1v5H1zm46 3h-1V5h1v5zM2 5H1c0-2 1-4 3-4v1C3 2 2 3 2 5zm43-2-3-2V0l4 3h-1zM35 0h5v1h-5zm-8 0h5v1h-5zm-7 0h5v1h-5zm-7 0h5v1h-5zM6 0h5v1H6zm7 46h3v1h-3zM40 6 9 27h9L0 47l33-20h-8z" />
  </svg>
)
